__turbopack_context__.v({
  "className": "SCZ5cG_className",
});
